module.exports = __webpack_public_path__ + "static/media/syncui_125.04b9597c.ico";